import vars from 'src/utils/vars';
// @ts-expect-error
import gapi from 'gapi';
import {SocialLogin} from '@capgo/capacitor-social-login';
import {noop} from 'lodash';
import PlatformService from '../../src/services/PlatformService';

const clientId = vars.googleClientId || '';

interface GoogleUserData {
  email: string | null;
  idToken: string | null;
  accessToken: string | null;
}

const GoogleOAuth = {
  init: (scope = undefined, discoveryDocs = [], cb = noop) => {
    if (PlatformService.isNativeApp()) {
      return GoogleOAuth.nativeInit(cb);
    } else {
      return GoogleOAuth.webInit(scope, discoveryDocs, cb);
    }
  },
  nativeInit: async (cb = noop) => {
    await SocialLogin.initialize({
      google: {
        webClientId: clientId,
        // iOS always uses this client id and no one else does, so it's safe to hardcode
        iOSClientId: '947729708738-867udontjaa6diosfepv84vsvudhd912.apps.googleusercontent.com',
      },
    });

    cb();
  },
  webInit: (scope, discoveryDocs = [], cb = noop) => {
    if (Array.isArray(scope)) {
      scope = scope.join(' ');
    }

    gapi.load('auth2', () => {
      if (!gapi.auth2.getAuthInstance() && clientId && clientId !== '') {
        gapi.auth2
          .init({
            client_id: clientId,
            scope,
            discoveryDocs,
            plugin_name: 'google',
          })
          .then(cb, (reason) => `Failed to intialize google authentication: ${reason}`);
      }
    });
  },
  authorize: async (): Promise<GoogleUserData> => {
    if (PlatformService.isNativeApp()) {
      return GoogleOAuth.nativeAuthorize();
    } else {
      return GoogleOAuth.webAuthorize();
    }
  },
  webAuthorize: async (): Promise<GoogleUserData> => {
    const googleUser = await gapi.auth2.getAuthInstance().signIn({prompt: 'select_account'});

    return {
      email: googleUser.getBasicProfile().getEmail(),
      idToken: googleUser.getAuthResponse().id_token,
      accessToken: googleUser.getAuthResponse().access_token || null,
    };
  },
  nativeAuthorize: async (): Promise<GoogleUserData> => {
    const googleUser = await SocialLogin.login({
      provider: 'google',
      options: {
        forceRefreshToken: true,
        scopes: undefined,
      },
    });

    if (googleUser.result.responseType !== 'online') {
      throw new Error('Google OAuth login failed: responseType is not online');
    }

    return {
      email: googleUser.result.profile.email,
      idToken: googleUser.result.idToken,
      accessToken: googleUser.result.accessToken?.token || null,
    };
  },
};

export default GoogleOAuth;
